// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

import { DispositionCategory } from './dispositionCategory';

export class DispositionResponse {
    chatId: string;
    dispositions: DispositionCategory[];
}